// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Lightbox Custom Styles */
.lightbox-toolbar {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1000;
}
.lightbox-toolbar .info-button {
  background: rgba(0, 0, 0, 0.7);
  border: none;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}
.lightbox-toolbar .info-button:hover {
  background: rgba(0, 0, 0, 0.9);
}
.lightbox-toolbar .metadata-panel {
  position: absolute;
  top: 50px;
  right: 0;
  background: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 1rem;
  border-radius: 8px;
  min-width: 250px;
}
.lightbox-toolbar .metadata-panel .metadata-item {
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}
.lightbox-toolbar .metadata-panel .metadata-item:last-child {
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/ImageViewer/lightbox.less"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;AACJ;AALA;EAOQ,8BAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AACR;AACQ;EACI,8BAAA;AACZ;AArBA;EAyBQ,kBAAA;EACA,SAAA;EACA,QAAA;EACA,8BAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AADR;AA/BA;EAmCY,qBAAA;EACA,iBAAA;AADZ;AAGY;EACI,gBAAA;AADhB","sourcesContent":["/* Lightbox Custom Styles */\n.lightbox-toolbar {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    z-index: 1000;\n    \n    .info-button {\n        background: rgba(0,0,0,0.7);\n        border: none;\n        color: white;\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        transition: all 0.3s ease;\n        \n        &:hover {\n            background: rgba(0,0,0,0.9);\n        }\n    }\n    \n    .metadata-panel {\n        position: absolute;\n        top: 50px;\n        right: 0;\n        background: rgba(0,0,0,0.9);\n        color: white;\n        padding: 1rem;\n        border-radius: 8px;\n        min-width: 250px;\n        \n        .metadata-item {\n            margin-bottom: 0.5rem;\n            font-size: 0.9rem;\n            \n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
